import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Page } from 'src/app/core/models/page';
import { faAngleLeft,faAngleRight,faAngleDoubleLeft,faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs/internal/Subject';
@Component({
  selector: 'app-mansel-pagination',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './mansel-pagination.component.html',
  styleUrls: ['./mansel-pagination.component.scss']
})
export class ManselPaginationComponent implements OnInit,OnDestroy  {
  faAngleLeft=faAngleLeft;
  faAngleRight=faAngleRight;
  faAngleDoubleLeft=faAngleDoubleLeft;
  faAngleDoubleRight=faAngleDoubleRight;
  @Input('pageIn') pageIn: Page;
  @Input('manuelPageNumber') manuelPageNumber: boolean;
  @Output() setManselPaginePageEvent: EventEmitter<any> = new EventEmitter<any>();
  pageNumberManuel=new FormControl("")
  destroy$: Subject<boolean> =new Subject<boolean>();
  constructor() { }

  ngOnDestroy(): void{
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit() {
    this.pageNumberManuel.valueChanges.pipe(debounceTime(500),distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
      this.setPageNumber(data);
    }) 
  }
  
  setPageNumber(pageNumber) {
    if (pageNumber >= 1 && pageNumber <= this.pageIn.totalPages) {
      this.pageIn.pageNumber = pageNumber;
      this.setManselPaginePageEvent.emit(this.pageIn);
    }
  }   
}